import { Component, OnInit } from '@angular/core';

import { Localidade } from "../shared/localidade.model";
import { localidadesModuleName } from "../shared/data.service";
import { LocalidadeApiService } from "../shared/localidade-api.service";
import { LocalidadeNavigationService } from "../shared/localidade-navigation.service";
import { UtilService } from "../../../shared/services/util.service";
import { EnderecoService } from "../../enderecos/shared/endereco.service";
import {LocalidadeService} from "../shared/localidade.service";

@Component({
    template: require('./localidade-list.component.html'),
    styles: [require('./localidade-list.component.css')]
})
export class LocalidadeListComponent implements OnInit {
    list: Localidade[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    localidadesModuleName: any = localidadesModuleName;

    constructor(
        private _localidadesApiService: LocalidadeApiService,
        private _localidadeNavigationService: LocalidadeNavigationService,
        private _localidadeService: LocalidadeService,
        private _utilService: UtilService,
        private _enderecoService: EnderecoService
    ) { }

    ngOnInit() {
        this.getAll();
    }

    clickNew() {
        this._localidadeService.clearSessionStorage();
        this._localidadeNavigationService.goToNew();
    }

    clickEdit(item: Localidade) {
        this._localidadeService.clearSessionStorage();
        this._localidadeNavigationService.goToEdit(item.id);
    }

    clickDelete(item: Localidade) {
        var onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private getAll() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: any, lenX: any;
                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    if (Response[x].endereco) {
                        Response[x].address = this._enderecoService.getAddress(Response[x].endereco);
                    }
                }

                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._localidadesApiService.onGetAll(onDone);
    }

    private onDelete(item: any) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._localidadesApiService.onDelete(item.id, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/localidades/localidade-list/localidade-list.component.ts
 **/